module.exports = __webpack_public_path__ + "img/img10.068436d7.png";